import { ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, EventEmitter, Output, ViewChild, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import { extractDateAsString, unsubscribeSubscriptions, getUserProfile} from '../../../shared/services/util.service';
import * as fromSelectors from '../../../store/delivery-checklist/delivery-checklist.selectors';
import * as fromActions from '../../../store/delivery-checklist/delivery-checklist.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { ICustomer } from '@signal/asp-data-commons/lib/interfaces/appointment';
import { SearchCustomersState } from '../../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer } from '../../../store/search-customers/search-customers.selectors';
import * as fromSelector from './../../../store/dealer/dealer.selectors';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';
import { TranslateService } from '@ngx-translate/core';
import * as fromValidator from '../../../bdc/service-appointment/service-appointment.validator';
import { VehicleService } from '../../../shared/services/vehicle.service';
import { ContactEmailInfoComponent } from '../../../bdc/shared/contact-email-info/contact-email-info.component';
import { CustomerInfoComponent } from '../../../bdc/shared/customer-info/customer-info.component';
import { DeliveryChecklistState } from 'src/app/modules/store/delivery-checklist/delivery-checklist.reducer';
import { DateAdapter } from '@angular/material/core';
import { DeliveryChecklistService } from 'src/app/modules/shared/services/delivery-checklist.service';
import { DateTime } from 'luxon';
import { SourceSystem, VehicleStatus, CustomerType } from '@signal/asp-data-commons/lib/enums/enum';

@Component({
  selector: 'app-vehicle-customer-details',
  templateUrl: './vehicle-customer-details.component.html',
  styleUrls: ['./vehicle-customer-details.component.scss']
})
export class VehicleCustomerDetailsComponent implements OnInit, OnDestroy {
  @Output() formEdited: EventEmitter<boolean> = new EventEmitter();
  @Input() isUpdate: boolean;
  @Input() digiChekId: string;
  @Input() vin:string;
  @Output() enableSubmitButton: EventEmitter<boolean> = new EventEmitter();

  customerDetails$: Observable<ICustomer>;
  check = false;
  vehicleDetails: any = {
    yearMakeModel: '',
    vin: '',
    stockNo: 'NA',
    trim: 'XE',
    certificationStatus: '',
    source: '',
    make: '',
    dealerCategory: '',
    dealerSubCategory: '',
    estimatedDealerArrival: '',
    dealerCode: '',
    unitId: 123,
    isTestDrive: false,
    isSafetyCampaign:false,
    isNonSafetyCampaign:false,
  };
  lastValue
  isStoreUpdate = false;
  storeValue
  deliveryForm: UntypedFormGroup;
  private readonly contactEmailInfoForm: UntypedFormControl;
  subscriptions: SubscriptionList = {};
  private signedInUserDetails: ICustomer;
  searchVinForm: UntypedFormGroup;
  loggedInUser = "";
  load = false;
  isVinValid = false;
  dateFormat = 'yyyy-MM-dd';
  dealerCode$: Observable<string>;
  dealerCode: string;
  message: string;
  date: string;
  data: any;
  minDate: string;
  isToday=true;
  showMandatoryMsgCI = false;
  type="DIGI_CHK";
  showStatusLabel=false;
  vehicleStatusLabel='';
  @ViewChild(ContactEmailInfoComponent, { static: false }) contactEmailInfoComponent: ContactEmailInfoComponent;
  @ViewChild(CustomerInfoComponent, { static: false }) customerInfoComponent: CustomerInfoComponent;

  constructor(
    private readonly viewportScroller: ViewportScroller,
    private readonly bannerService: AspBannerService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly deliveryChecklistState: Store<DeliveryChecklistState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly dealerState: Store<DealerState>,
    private readonly translate: TranslateService,
    private readonly vehicleService: VehicleService,
    private readonly cdref: ChangeDetectorRef,
    private readonly dateAdapter: DateAdapter<Date>,
    private readonly deliveryChecklistService: DeliveryChecklistService,
    private readonly checklistStore: Store<DeliveryChecklistState>) {
    this.dateAdapter.setLocale(this.translate.currentLang);
    this.searchVinForm = this.formBuilder.group({
      isOwnVehicle: [false],
      isInputVinBased: [true],
      vin: ['', [Validators.required]],
      mileage: [1]
    });
    this.searchVinForm.setValidators(fromValidator.chooseVehicleValidator());
    this.initializeDeliveryForm();
    this.subscriptions.searchVinFormSub = this.searchVinForm.valueChanges.subscribe(_vin => {
      this.formEdited.emit(!this.searchVinForm.dirty);
    });
    this.dealerCode$ = this.dealerState.select(fromSelector.selectDealerCode);
    this.subscriptions.dealerSubscription = this.dealerCode$.subscribe(code => {
      this.dealerCode = code;
    });
    this.minDate = DateTime.now().toISO();
  }

  ngAfterContentChecked() {
    if (!this.cdref['destroyed']) {
      this.cdref.detectChanges();
    }
  }

  initializeDeliveryForm() {
    this.deliveryForm = this.formBuilder.group({
      vehicle: this.formBuilder.group({
        exteriorColor: null,
        model: null,
        trim: null,
        year: null,
        make: null,
        imageUrl: null,
        vin: null,
        dealerCategory: null,
        unitId: null,
        source: null,
        dealerCode: null,
        seriesCode: null,
        marketingSeries: null,
        fuelType: null,
        isSafetyCampaign:null,
        isNonSafetyCampaign:null,
        onGroundDate: [''],
      }),
      dateOfAcquired: ['', [Validators.required]],
      dateOfDeletion: ['',],
      scheduledTime: [''],
      salesConsultant: ['', [Validators.required]],
      customer: this.contactEmailInfoForm
    });
    this.onValueChange();
  }

  hasError(controlName: string) {
    return this.searchVinForm[controlName]?.length ? false : true;
  }

  checkForExistingChecklist(vin) {
    this.subscriptions.vinSubscription = this.deliveryChecklistService.getChecklistsForVin(vin).subscribe(data => {
      const result = data?.data;
      if (result?.vehicle?.vin === vin.toUpperCase()) {
        this.checkSummary();
        this.disableCalendar(result.vehicle);
      } else {
        this.getVehicleDetails();
      }
    }, error => {
      if (error.status === 404 && error.statusText === 'OK') {
        this.getVehicleDetails();
      }else if(error.status === 500){
        this.message = 'deliveryChecklist.checklistAlreadyCreatedMsg';
        this.load = false;
        this.isVinValid = false;
        this.vehicleDetails.yearMakeModel = '';
        this.vehicleDetails.vin = '';
        this.vehicleDetails.isAlreadyBooked = true;
      }
    });
  }

  submitVinForm() {
    if (this.searchVinForm.valid) {
      this.load = true;
      this.vehicleDetails.isAlreadyBooked = false;
      const vin = this.searchVinForm.get('vin').value;
      this.subscriptions.vehicleDetailsSub = this.vehicleService.getVehicleDetails({ vin }, true).subscribe(result => {
        if (result.data.length) {
          this.data = result.data[0];
          this.checkForExistingChecklist(vin);
        }
        else {
          this.load = false
          this.isVinValid = false
          this.vehicleDetails.isInvalid = true
          this.vehicleDetails.yearMakeModel = ''
          this.vehicleDetails.vin = ''
          this.vehicleDetails.isDealerDifferent = false;
          this.vehicleDetails.isInvalidCat = false;
          this.disableCalendar(null);
        }
      });
    }
  }

  checkSummary() {
    this.vehicleDetails = {
      yearMakeModel: '',
      vin: '',
      stockNo: '',
      trim: '',
      source: '',
      make: '',
      dealerCategory: '',
    };
    this.vehicleDetails.isAlreadyBooked = true;
    this.message = 'deliveryChecklist.checklistAlreadyCreatedMsg';
    this.isVinValid = false;
    this.load = false;
  }

  getVehicleDetails() {
    if (this.data.vin && this.data.make && this.data.description && this.data.year) {
      const vehicleData = {
        ...this.vehicleDetails,
        vin: this.data.vin,
        yearMakeModel: (this.data?.model) ? `${this.data.year} ${this.data.make} ${this.data.model}` : `${this.data.year} ${this.data.make} ${this.data.description}`,
        isInvalid: false,
        make: this.data.make,
        certificationStatus: this.data?.certificationStatus,
        source: this.data.source,
        stockNo: this.data?.stockNo || "NA",
        unitId: this.data?.unitId,
        dealerCode: this.data.dealerCode,
        dealerCategory: this.data.dealerCategory,
        dealerSubCategory: this.data?.dealerSubCategory,
        estimatedDealerArrival: this.data.estimatedDealerArrival,
        isDealerDifferent: this.data.dealerCode !== this.dealerCode,
        isInvalidCat: false,
        isSafetyCampaign:this.data.isSafetyCampaign,
        isNonSafetyCampaign:this.data.isNonSafetyCampaign,
      };
      this.load = false;
      this.formStatusLabel(vehicleData);
      this.bannerService.showCarImage();
      this.bannerService.update(this.data.imageUrl);
      this.vehicleDetails = { ...vehicleData };
      this.deliveryForm.get('vehicle').patchValue({
        model: this.data?.model || this.data?.description,
        year: this.data.year,
        make: this.data.make,
        imageUrl: this.data.imageUrl,
        vin: this.data.vin,
        dealerCategory: this.data?.dealerCategory,
        source: this.data?.source,
        dealerCode: this.data?.dealerCode,
        unitId: this.data?.unitId,
        seriesCode: this.data?.seriesCode,
        marketingSeries: this.data?.marketingSeries,
        fuelType: this.data?.fuelType,
        isSafetyCampaign:this.data.isSafetyCampaign,
        isNonSafetyCampaign:this.data.isNonSafetyCampaign
      })
      this.isVinValid = true;
      this.disableContinueButton(this.data);
      this.disableCalendar(this.data);
    }
  }

  disableContinueButton(data:any)
  {
    if(data.dealerCode!==this.dealerCode)
    {
      this.enableSubmitButton.emit(false); 
    }
    else if( (data?.dealerCategory===VehicleStatus.A) || (data?.dealerCategory===VehicleStatus.F))
    {
      this.vehicleDetails.isInvalidCat = true;
      this.enableSubmitButton.emit(false); 
    }
    else if(data.source===SourceSystem.NVI && data.isSafetyCampaign)
    {
      this.enableSubmitButton.emit(false); 
    }
    else {
      this.checklistStore.dispatch(new fromActions.LoadChecklist({fuelType: data?.fuelType}));
      this.enableSubmitButton.emit(true);
    }
  }

  formStatusLabel(vehicleDetails: any) {
    this.showStatusLabel = false;
    if (vehicleDetails.isSafetyCampaign) {
      this.showStatusLabel = true;
      this.vehicleStatusLabel = 'deliveryChecklist.stopSale';
    }
    else if (vehicleDetails.dealerCategory === VehicleStatus.A || vehicleDetails.dealerCategory === VehicleStatus.F || vehicleDetails.isDealerDifferent) {
      this.showStatusLabel = true;
      this.vehicleStatusLabel = 'deliveryChecklist.pendingVehicleArrival';
    }
  }

  onSearchChange(): void {
    this.vehicleDetails.isInvalid = false
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.bannerService.show();
    this.loggedInUser = getUserProfile()?.name?.prefferedName
    this.setupStore();
    if(this.vin){
      this.searchVinForm.get('vin').patchValue(this.vin);
      this.submitVinForm();
    }
  }

  isFormEdited() {
    return !(
      this.customerInfoComponent?.customerInfo?.dirty ||
      this.deliveryForm.controls.dateOfAcquired?.dirty ||
      this.deliveryForm.controls.salesConsultant?.dirty ||
      this.contactEmailInfoComponent?.contactEmailInfo?.dirty ||
      this.searchVinForm.dirty);
  }

  onValueChange() {
    this.subscriptions.testDriveSub = this.deliveryForm.valueChanges.subscribe(value => {
      this.formEdited.emit(this.isFormEdited());

      /* *this is to choose selected vehicle during edit mode*/
      if (value?.vehicle?.model && this.isUpdate) {
        this.vehicleDetails.yearMakeModel = `${value.vehicle.year} ${value.vehicle.make} ${value.vehicle.model}`;
        this.vehicleDetails.vin = value.vehicle.vin;
        this.vehicleDetails.make = value.vehicle.make;
        if (!this.vehicleDetails?.dealerCode && !this.check) {
          this.check = true;
          this.subscriptions.vehicleDetailsSub = this.vehicleService.getVehicleDetails({ vin: value?.vehicle?.vin }, true).subscribe((data) => {
            const vehicle = { ...this.vehicleDetails };
            vehicle.dealerCode = data.data[0]?.dealerCode;
            vehicle.dealerCategory = data.data[0]?.dealerCategory;
            vehicle.dealerSubCategory = data.data[0]?.dealerSubCategory;
            vehicle.estimatedDealerArrival = data.data[0]?.estimatedDealerArrival;
            vehicle.source = data.data[0]?.source;
            vehicle.certificationStatus = data.data[0]?.certificationStatus;
            vehicle.stockNo = data.data[0]?.stockNo || "NA";
            vehicle.unitId = data.data[0]?.unitId;
            vehicle.fuelType = data.data[0]?.fuelType;
            vehicle.isSafetyCampaign = data.data[0]?.isSafetyCampaign;
            vehicle.isNonSafetyCampaign = data.data[0]?.isNonSafetyCampaign;
            this.vehicleDetails = { ...vehicle };
            this.formStatusLabel(vehicle);
            this.disableContinueButton(this.vehicleDetails);
            this.disableCalendar(value.vehicle);
          })
        }
      }
      if (value?.customer?.emailAddress) {
        value.customer.emailAddress = value.customer.emailAddress.trim();
      }
      const val = { ...value }
      delete val.vehicle;

      /*Updating storeValue = undefined everytime the form is updated to the initial changes from the state */
      if (this.storeValue && _.isEqual(this.storeValue, val)) {
        this.storeValue = undefined;
        this.isStoreUpdate = false;

        /* for the very first time lastValue, storeValue and value will be equal,
         hence the storeValue will be undefined. To handle this scenario we are
         reassigning the same value from the store*/
        if (_.isEqual(this.lastValue, value)) {
          this.storeValue = this.lastValue;
          delete this.storeValue.vehicle
        }
      }

      if (_.isEqual(this.lastValue, value)) {
        return;
      }

      this.isStoreUpdate = false;

      /*lastValue keeps changing everytime the form value changes
       (even when the changes are from the initialstate or EditState) */
      this.lastValue = value;
      this.matchDeliveryDate();
      /*dispatch happens only when the storeValue = undefined which means
      that all the initial changes (initialState and EditState) from store are
      populated in the form and now we are dispatching the changes done by the user*/
      if (!this.storeValue) {
        this.deliveryChecklistState.dispatch(new fromActions.UpdateFormData({ value }));
      }
    });

  }

  disableCalendar(vehicle:any): void {
    const control = this.deliveryForm.controls?.dateOfAcquired;
    if(vehicle?.dealerCategory){
      const dealerCategory = vehicle.dealerCategory;
      const isSafetyCampaign = vehicle.isSafetyCampaign;
      const control = this.deliveryForm.controls?.dateOfAcquired;
      if (['A', 'F'].includes(dealerCategory)
      || (['A', 'F', 'G'].includes(dealerCategory) && isSafetyCampaign)
      || isSafetyCampaign) {
        control?.disable();
          if (isSafetyCampaign && !!control?.value) {
            control?.patchValue('');
          }
      }else {
        control?.enable();
      }
    } else {
      control?.enable();
    }
  }

  checkPhoneNumber(number) {
    if (number && number.length) {
      const code = number.substring(0, number.length - 10)
      if (code === '+1' && number.length === 12) {
        return true
      } else if (code === '+52' && number.length === 13) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }

  }

  checkCustomerForm() {
    return this.deliveryForm.controls.customer.value.firstName.length && this.deliveryForm.controls.customer.value.lastName.length && this.checkPhoneNumber(this.deliveryForm.controls.customer.value.phoneNumber) && this.deliveryForm.controls.customer.valid;
  }

  isValidForm() {
    /* dateOfAcquired should be todays date to make the form valid */
    return (this.digiChekId ? true : this.isVinValid) &&
      this.deliveryForm.controls.salesConsultant.valid &&
      this.deliveryForm.controls.dateOfAcquired.valid && 
      DateTime.fromISO(extractDateAsString(this.deliveryForm.controls.dateOfAcquired.value)).toFormat(this.dateFormat) === DateTime.now().toFormat(this.dateFormat) &&
      this.deliveryForm.controls.vehicle.valid && this.checkCustomerForm();
  }

  isValidSaveForLaterForm() {
    return (this.digiChekId ? true : this.isVinValid) &&
      this.deliveryForm.controls.vehicle.valid && this.checkCustomerForm();
  }

  setupStore() {
    this.setSignedInUserDetails();
    this.subscriptions.appointmentDetails = this.deliveryChecklistState.select(fromSelectors.DigitalChecklistDetails).subscribe((data) => {
      const value = { ...data,salesConsultant: this.loggedInUser };
      delete value.checklistRequest;
      delete value.deliveryConsultant;
      delete value.customerSignId;
      delete value.descriptionOfProductsOrServices;

      if (_.isEqual(this.lastValue, value)) {
        return;
      }
      this.lastValue = value;
      this.isStoreUpdate = true;

      /*isUpdate -> During edit mode we need to store the state value thats coming in,
       so that we can check the incoming form changes against storeValue
       isStoreUpdate -> Phase 2 (basically used when changes are invoked from state during create mode)*/
      if (this.isUpdate || this.isStoreUpdate) {
        this.storeValue = { ...value };
        delete this.storeValue.vehicle;
      }

      this.deliveryForm.patchValue(value);
    });
  }
  setSignedInUserDetails() {
    this.customerDetails$ = this.searchCustomersState.select(selectCurrentCustomer);
    this.subscriptions.customerSub = this.customerDetails$
      .subscribe(customer => {
        this.signedInUserDetails = {
          firstName: customer?.firstName || '',
          lastName: customer?.lastName || '',
          emailAddress: !customer?.drvaFlag ? customer?.emailAddress : '',
          phoneNumber: !customer?.drvaFlag ? customer?.phoneNumber : ' ',
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || ''
        };
        this.deliveryChecklistState.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      });
  }

  nextClicked() {
    this.dateAdapter.setLocale(this.translate.currentLang);
  }

  getTranslation(value) {
    const key = `common.${value}`;
    return value ? `${this.translate.instant(key)}` : value;
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.cdref.detach();
  }

  isCIformValid(event) {
    this.showMandatoryMsgCI = event;
  }

  matchDeliveryDate()
  {
    const deliveryDate=this.deliveryForm.controls.dateOfAcquired.value;
    if(deliveryDate)
    {
      const date=new Date(deliveryDate);
      const today=DateTime.now();
      this.isToday=today.year===date.getFullYear() && today.month===date.getMonth()+1 && today.day===date.getDate()
    }
  }
}
